<template>
    <div class="mt-3">
        <div class="card d-print-none">
            <h5 class="card-header">
                {{ $t('media') }}
            </h5>
            <div class="card-body">
                <div class="form-group">
                    <label for="language_id">
                        {{ $t('mediaLanguage') }}
                    </label>

                    <form-select
                        v-model="localLanguageId"
                        name="language_id"
                        :endpoint="`/subscriber/api/lessons/${lessonId}/languages-options`"
                        :watch-variable="lessonId"
                    />
                </div>

                <div
                    v-if="isLoading"
                    class="alert alert-warning"
                    role="alert"
                >
                    {{ $t('loading') }}...
                </div>

                <div
                    v-if="(! isLoading && rows && ! rows.length)"
                    class="alert alert-warning"
                    role="alert"
                >
                    {{ $t('noMedia') }}
                </div>

                <div
                    v-if="((isLoading === false) && rows.length)"
                    class="list-group"
                >
                    <div
                        v-for="row in rows"
                        :key="row.id"
                        class="list-group-item list-group-item-action"
                    >
                        <a :href="`/lessons/${lessonId}/media/${row.id}`">
                            {{ row.name }}
                        </a>

                        <a
                            :href="`/lessons/${lessonId}/media/${row.id}`"
                            class="btn btn-primary btn-sm float-end"
                        >
                            {{ $t('download') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import FormSelect from '../../form-components/FormSelect.vue';

export default {
    components: {
        FormSelect,
    },

    props: {
        lessonId: {
            type: Number,
            required: true,
        },
        languageId: {
            type: [Number, String],
            default: null,
        },
    },

    data() {
        return {
            isLoading: null,
            rows: null,
            localLanguageId: this.languageId,
        };
    },

    watch: {
        lessonId: function () {
            this.getRows();
        },

        languageId: function (value) {
            this.localLanguageId = value;
            this.$i18n.locale = value;
            this.getRows();
        },

        localLanguageId: function (value) {
            this.$i18n.locale = value;
            this.getRows();
        },
    },

    mounted: function () {
        this.getRows();
    },

    methods: {
        getRows: function () {
            this.isLoading = true;
            this.rows = [];

            axios({
                method: 'get',
                url: `/subscriber/api/lessons/${this.lessonId}/media/`,
                params: {
                    'language_id': Number(this.localLanguageId),
                },

            })
            .then((response) => {
                this.rows = response.data;
                this.isLoading = false;
            })
            .catch(() => {});
        },
    },
};
</script>
